import React from 'react';

import PublicPage from 'components/PublicPage';

const Home = ({navbarProps}) => (
    <PublicPage navbarProps={navbarProps}>
        <div className="container">
            <div className="content">
                <h1 className="title is-1">Otoschool Eleve</h1>
                <h2 className="title is-2">Passez votre code en ligne</h2>
            </div>
            <div className="content">
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias autem vero voluptate nesciunt natus. Voluptatum necessitatibus dolor et quam iusto. Fugiat laboriosam perspiciatis ipsam fuga dolorem tempore enim mollitia ut!
                </p>
            </div>
        </div>
    </PublicPage>
)

export default Home;